export default __webpack_public_path__ + "static/media/Ballroll_00198.68d2e702.png";